export enum MAGIC_LINK {
    /**
     * @value Email me a login link
     */
    EMAIL_ME_LINK = 'MAGIC_LINK.EMAIL_ME_LINK',
    /**
     * @value We have sent a sign-in link to
     */
    LINK_HAS_BEEN_SENT_TO = 'MAGIC_LINK.LINK_HAS_BEEN_SENT_TO',
    /**
     * @value Sign in with a link
     */
    SIGN_IN_WITH_LINK = 'MAGIC_LINK.SIGN_IN_WITH_LINK',
}
